<div class="modal-header">
  <h4 class="modal-title pull-left"> Preview of {{name}} </h4>
  <div aria-label="Close" (click)="onCancel()" class="close pull-right">
    <span aria-hidden="true">×</span></div>
</div>

<div class="modal-body">
 <pdf-viewer [fit-to-page]="true" [zoom]="zoom" [autoresize]="true" [original-size]="false" [show-all]="true"
   [src]="source" [render-text]="true" style="display: block"></pdf-viewer>
</div>

<div class="modal-footer">

  <div class="button-wrapper mr-auto">
     <button type="button" (click)="zoomOut()" class="btn btn-rbv">
       <i class="fa fa-search-minus fa-lg" aria-hidden="true"></i>
     </button>

     <button type="button" (click)="zoomIn()" class="btn btn-rbv">
       <i class="fa fa-search-plus fa-lg" aria-hidden="true"></i>
     </button>

    <button type="button" (click)="fitToPage()" class="btn btn-rbv">
        Fit to page
      </button>
  </div>

  <button class="btn btn-rbv" (click)="onCancel()">OK</button>
</div>
